import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .section-header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  h2 {
    font-size: clamp(2.6rem, 4vw, 3.2rem);
  }

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.18rem;
    color: var(--muted);
    font-weight: 600;
    font-size: 1.2rem;
  }

  .muted {
    color: var(--muted);
  }

  .contact-grid {
    display: grid;
    grid-template-columns: 0.9fr 1.1fr;
    gap: 1.6rem;
    align-items: start;
  }

  .card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 18px;
    padding: 2rem;
    box-shadow: var(--shadow);
  }

  .quick-card {
    display: grid;
    gap: 1.2rem;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    border: 1px solid var(--border);
    border-radius: 14px;
    padding: 1.2rem 1.4rem;
    background: var(--pill-bg);
  }

  .icon-circle {
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: var(--gradient);
    border: 1px solid var(--border);

    img {
      width: 2.2rem;
    }
  }

  .label {
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    color: var(--muted);
    font-size: 1.2rem;
    font-weight: 700;
  }

  .value {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--text);
  }

  .form-card {
    padding: 2rem;
  }

  @media (max-width: 900px) {
    .contact-grid {
      grid-template-columns: 1fr;
    }
  }
`
